import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';

class ProvidersReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
        };
    }

    componentDidMount() {
        this.getProviders();
    }

    getProviders() {
        $.ajax({
            url: this.props.url,
            data: { limit: this.props.perPage, offset: this.state.offset },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState(
                    {
                        data: data.providers,
                        pageCount: Math.ceil(data.total / this.props.perPage),
                    },
                    () => {
                        console.log(this.state);
                    }
                );
            },

            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.getProviders();
        });
    };

    handleClick = (url) => {
        window.location.href = url;
    };

    handleChange = (e) => {
        this.setState(
            {
                offset: 0,
            },
            () => {
                this.getProviders();
            }
        );
    };

    render() {
        let providers = this.state.data.map((provider) => {
            return (
                <tr key={provider.id}>
                    <td className="text-center">{provider.id}</td>
                    <td className="text-center">{provider.name}</td>
                    <td className="text-center text-none">{provider.email}</td>
                    <td className="text-center">{provider.completed_jobs_count}</td>
                    <td className="text-center">{provider.declined_jobs_count}</td>
                    <td className="text-center">{provider.waste_journeys_count}</td>
                </tr>
            );
        });

        return (
            <Fragment>
                <table className="table transform-text">
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Email</th>
                            <th className="text-center">Jobs completed</th>
                            <th className="text-center">Declined jobs</th>
                            <th className="text-center">Wasted journeys</th>
                        </tr>
                    </thead>
                    <tbody>{providers}</tbody>
                </table>
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
            </Fragment>
        );
    }
}

if (document.getElementById('providers-reports')) {
    let element = document.getElementById('providers-reports');
    ReactDOM.render(
        <ProvidersReports url={JSON.parse(element.dataset.url)} perPage={JSON.parse(element.dataset.per_page)} />,
        element
    );
}
